/**
 * @description selector to get all engineers.
 * @param state
 * @return {*}
 */
export const getServicesSelector: (state: any) => OverviewService[] = state => (state?.Services?.data ? state.Services.data : []);
